import * as selectors from './selectors';
import { all, call, fork, put, takeEvery, select } from 'redux-saga/effects';
import { fetchInsuredPerson, fetchInsuredPersonError, fetchInsuredPersonSuccess, updateLanguageInsuredPerson, updateLanguageInsuredPersonFailed, updateLanguageInsuredPersonSuccess } from './actions';

import { DetailsInsuredPersonActionTypes } from './types';
import { getInsuredPerson } from '../../utils/api/casesApi';
import { updatePartyLanguage } from 'src/store/utils/api/partyApi';
import { SagaIterator } from 'redux-saga';

function* handleFetchInsuredPerson(action: ReturnType<typeof fetchInsuredPerson>): SagaIterator {
  try {
    const res = yield call(getInsuredPerson, action.payload.caseCode);

    if (!res.data) {
      yield put(fetchInsuredPersonError(JSON.stringify(res.response)));
    } else {
      yield put(fetchInsuredPersonSuccess(res.data));
    }
  } catch (err) {
    if (err instanceof Error) {
      yield put(fetchInsuredPersonError(`${err.message}\n${err.name}\n${err.stack}`));
    } else {
      yield put(fetchInsuredPersonError('An unknown error occured.'));
    }
  }
}

function* handleUpdateInsuredPersonLanguage(action: ReturnType<typeof updateLanguageInsuredPerson>): SagaIterator {
  try {
    const insuredPerson = yield select(selectors.selectedCaseInsuredPerson);
    const res = yield call(updatePartyLanguage, insuredPerson.id, action.payload.instructionId, action.payload.languageTC);

    if (!res.data) {
      yield put(updateLanguageInsuredPersonFailed(JSON.stringify(res.response)));
    } else {
      yield put(updateLanguageInsuredPersonSuccess());
    }
  } catch (err) {
    if (err instanceof Error) {
      yield put(updateLanguageInsuredPersonFailed(`${err.message}\n${err.name}\n${err.stack}`));
    } else {
      yield put(updateLanguageInsuredPersonFailed('An unknown error occured.'));
    }
  }
}

function* watchDetailsInsuredPerson() {
  yield takeEvery(DetailsInsuredPersonActionTypes.FETCH_INSURED_PERSON, handleFetchInsuredPerson);
  yield takeEvery(DetailsInsuredPersonActionTypes.UPDATE_LANGUAGE_INSURED_PERSON, handleUpdateInsuredPersonLanguage);
}

function* detailsInsuredPersonSaga() {
  yield all([fork(watchDetailsInsuredPerson)]);
}

export default detailsInsuredPersonSaga;
